import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
const Aside = () => {
    const location = useLocation();
    const [activePath, setActivePath] = useState(location.pathname);

    const handleActiveLink = (path) => {
        setActivePath(path);
    };

    return (
        <aside id="layout-menu" className="layout-menu-horizontal menu-horizontal menu bg-menu-theme flex-grow-0">
            <div className="container-xxl d-flex h-100">
                <ul className="menu-inner">
                    <li className={`menu-item ${activePath === '/' ? 'active' : ''}`}>
                        <Link to="/" className="menu-link" onClick={() => handleActiveLink('/')}>
                            <i className="menu-icon tf-icons bx bx-home-circle" />
                            <div data-i18n="Dashboard">Dashboard</div>
                        </Link>
                    </li>
                    {/* <li className={`menu-item ${activePath === '/users' ? 'active' : ''}`}>
                        <Link to="/users" className="menu-link" onClick={() => handleActiveLink('/users')}>
                            <i className="menu-icon tf-icons bx bx-user" />
                            <div data-i18n="Users">Lawyers</div>
                        </Link>
                        <ul className="menu-sub">
                            <li className="menu-item">
                                <a href="layouts-without-menu.html" className="menu-link">
                                    <i className="menu-icon tf-icons bx bx-menu" />
                                    <div data-i18n="Without menu">Without menu</div>
                                </a>
                            </li>
                            <li className="menu-item">
                                <a href="../vertical-menu-template/" className="menu-link" target="_blank" >
                                    <i className="menu-icon tf-icons bx bx-vertical-center" />
                                    <div data-i18n="Vertical">Vertical</div>
                                </a>
                            </li>
                            <li className="menu-item">
                                <a href="layouts-fluid.html" className="menu-link">
                                    <i className="menu-icon tf-icons bx bx-fullscreen" />
                                    <div data-i18n="Fluid">Fluid</div>
                                </a>
                            </li>
                            <li className="menu-item">
                                <a href="layouts-container.html" className="menu-link">
                                    <i className="menu-icon tf-icons bx bx-exit-fullscreen" />
                                    <div data-i18n="Container">Container</div>
                                </a>
                            </li>
                            <li className="menu-item">
                                <a href="layouts-blank.html" className="menu-link">
                                    <i className="menu-icon tf-icons bx bx-square-rounded" />
                                    <div data-i18n="Blank">Blank</div>
                                </a>
                            </li>
                        </ul>
                    </li> */}



                    <li className={`menu-item ${activePath === '/notarialbook' ? 'active' : ''}`}>
                        <Link to="/notarialbook" className="menu-link" onClick={() => handleActiveLink('/notarialbook')}>
                            <i className="menu-icon tf-icons bx bx-book" />
                            <div data-i18n="Notarial Book">Notarial Book</div>
                        </Link>
                    </li>

      



                </ul>
            </div>
        </aside>
    );
};

export default Aside;
